export type TimeOfDay = 'morning' | 'afternoon' | 'evening';

export class TimeOfDayHelper {
  /**
   * Buckets a date into morning (5–12), afternoon (12–18), or evening (everything else),
   * matching the boundaries used by the hero imagery and greeting copy.
   * @param date Optional date to use, defaults to current date
   */
  public static getTimeOfDay(date?: Date): TimeOfDay {
    const hour = (date || new Date()).getHours();
    if (hour >= 5 && hour < 12) return 'morning';
    if (hour >= 12 && hour < 18) return 'afternoon';
    return 'evening';
  }

  /**
   * @param date Optional date to use, defaults to current date
   * @returns "Good Morning" / "Good Afternoon" / "Good Evening" for the given time
   */
  public static getGreeting(date?: Date): string {
    const greetings: Record<TimeOfDay, string> = {
      morning: 'Good morning',
      afternoon: 'Good afternoon',
      evening: 'Good evening',
    };
    return greetings[this.getTimeOfDay(date)];
  }
}
